import { useEffect } from "react";
import { supabase } from "./lib/supabase";

export default function ProjectProcedureLibraryStateFix(){
  useEffect(()=>{
    let stopped=false;
    let busy=false;
    let timer:number|undefined;

    const currentProject=async()=>{
      const head=document.querySelector(".project-detail-head");
      const name=head?.querySelector("h1")?.textContent?.trim()||"";
      const number=head?.querySelector(".eyebrow")?.textContent?.trim()||"";
      let query=supabase.from("projects").select("id").limit(1);
      if(number&&number!=="PROJECT")query=query.eq("project_number",number);
      else query=query.eq("name",name);
      const {data}=await query.maybeSingle();
      return data?.id?String(data.id):null;
    };

    const sync=async()=>{
      if(stopped||busy)return;
      const boxes=[...document.querySelectorAll<HTMLElement>(".procedure-hierarchy-linkbox:not([hidden])")];
      if(!boxes.length)return;
      busy=true;
      try{
        const projectId=await currentProject();
        if(!projectId)return;
        const {data}=await supabase.from("project_procedures").select("procedure_id").eq("project_id",projectId);
        const projectLinks=new Set((data||[]).map(row=>String(row.procedure_id)));

        for(const box of boxes){
          const group=box.closest<HTMLElement>(".procedure-hierarchy-group");
          const wpsNumber=group?.querySelector(".procedure-hierarchy-parent div b")?.textContent?.trim()||"this WPS";
          const select=box.querySelector("select") as HTMLSelectElement|null;
          if(!select)continue;

          for(const option of [...select.options].slice(1)){
            const procedureId=option.value;
            const base=(option.textContent||"").replace(/\s*·\s*(already linked here|parented to this WPS · not on project|linked to this project)$/i,"").trim();
            const wasParentedHere=/already linked here|parented to this WPS/i.test(option.textContent||"");
            if(!wasParentedHere)continue;

            if(projectLinks.has(procedureId)){
              option.disabled=true;
              option.textContent=`${base} · linked to this project`;
            }else{
              option.disabled=false;
              option.textContent=`${base} · parented to ${wpsNumber} · not on project`;
            }
          }
        }
      }finally{busy=false}
    };

    const schedule=()=>{window.clearTimeout(timer);timer=window.setTimeout(()=>void sync(),80)};
    const observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:["hidden"]});
    document.addEventListener("click",schedule,true);
    schedule();
    return()=>{stopped=true;window.clearTimeout(timer);observer.disconnect();document.removeEventListener("click",schedule,true)};
  },[]);
  return null;
}
